// extracted by mini-css-extract-plugin
export default {"App":"App_App__SBSHL","switch-wrapper":"App_switch-wrapper__EDoFX"};